// Maximum number of task examples allowed per exam
export const MAX_TASK_EXAMPLES = 25;
